import { startOfLocalDay } from '../../../Utils/dates/localDay';

export const EARLIEST_DATE = '2020-01-01';

export const isValidDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return false;

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start < new Date(EARLIEST_DATE)) return false;
    if (end < start) return false;

    return true;
};

// startOfLocalDay lives in Utils/dates/localDay (shared with the dashboards); re-exported here.
export { startOfLocalDay };

const finiteOrZero = value => {
    const number = typeof value === 'number' ? value : Number.NaN;
    return Number.isFinite(number) ? number : 0;
};

// ATL/CTL state to carry into a range that opens on rest days: the server-calculated
// values of the latest completed workout before the range (assigned ones have none).
export const getLoadBaseline = (workouts, rangeStart) => {
    const rangeStartTime = startOfLocalDay(rangeStart).getTime();
    let latest = null;

    workouts.forEach(workout => {
        if (workout.status !== 'Completed') return;
        const time = new Date(workout.workoutStart).getTime();
        if (time >= rangeStartTime) return;
        if (!latest || time >= new Date(latest.workoutStart).getTime()) latest = workout;
    });

    if (!latest) return { prev: null, lastWorkoutDate: null };

    return {
        prev: { atl: finiteOrZero(latest.atl), ctl: finiteOrZero(latest.ctl) },
        lastWorkoutDate: startOfLocalDay(latest.workoutStart)
    };
};
